import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { InitiateBitcoinWithdrawalRequest } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/public.pb'
import { InitiateBitcoinWithdrawalResponse } from '@cash-web/shared-util-protos/squareup/cash/cryptosparky/api/public.pb'

export const initiateBitcoinWithdrawal = (request: InitiateBitcoinWithdrawalRequest, options?: CashRequestOptions) =>
  post<InitiateBitcoinWithdrawalRequest, InitiateBitcoinWithdrawalResponse>(
    '/2.0/cash/initiate-bitcoin-withdrawal',
    request,
    { ...options, rejectOnError: true }
  )
